<template>
  <div :class="['space', { mobile: isMobile }]">
    <section class="sec-1" ref="sec1">
      <div :class="['content']">
        <h3 class="title textfade textfade1" >城市数字孪生底座</h3>
        <p class="text textfade textfade2">将现实物理空间1:1数字线上化，结合物联网平台为用户提供线上物理空间仿真环境搭建，实现现实线上化、现实触达化、现实互动化，是“时空大数据平台”与“城市CIM平台”的重要组成部分。作为新型基础设施之一，城市数字孪生底座将打造城市数字经济2.0时代，为城市建设提供可感知、可触达、可决策的物理空间可视化平台。
        </p>
      </div>
      <div :class="['imgs', 'vivify fadeIn', { active: n > 0 }]">
        <div class="line" v-if="!isMobile" v-for="item in 32" :key="item"></div>
        <div class="line" v-if="isMobile" v-for="item in 13" :key="item"></div>
      </div>
      
      <div class="mac-video" v-if="!isMobile">
        <div class="video-wrap">
          <video
            :controls="false"
            :x5-video-player-fullscreen="true"
            controlslist="nodownload nofullscreen noremoteplayback"
            x5-video-player-type="h5"
            playsinline
            muted
            autoplay
            preload="metadata">
              <source src="/video/bigdata.mp4" type="video/mp4">
            </video>
        </div> 
      </div>
      <div class="mac"></div> 
      <div class="mark"></div>
      <show-more @handleSecond="handleSecond"></show-more>
    </section>

    <section :class="['sec-2', { active: n > 1 }]" ref="sec2">
      <div class="content">
        <h3 :class="['title textfade', { textfade1: n > 1 }]">
          支持多源数据接入数字孪生底座
        </h3>
        <p :class="['text textfade', { textfade2: n > 1 }]">
          面向大规模的CIM应用场景，针对多源数据融合呈现的场景需求，实现在城市数字孪生底座的基础上叠加多源异构数据和城市物联网数据，系统提供了丰富的数据接入接口，满足BIM、GIS、IoT等数据的系统化展示。
        </p>
      </div>

      <div :class="['imgs', { active: n > 1 }]" v-if="n > 0">
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_zhengwu.svg')
              : require('../assets/image/bigdata/pc_p2_zhengwu.png')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_ganzhi.svg')
              : require('../assets/image/bigdata/pc_p2_ganzhixinxi.png')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_minwu.svg')
              : require('../assets/image/bigdata/pc_p2_minwu.png')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_yunying.svg')
              : require('../assets/image/bigdata/pc_p2_yunying.png')
          "
          alt=""
          draggable="false"
        />

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_jianzhuwu.svg')
              : require('../assets/image/bigdata/pc_p2_jianzhuwu.png')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_dibiao.svg')
              : require('../assets/image/bigdata/pc_p2_dibiao.png')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_dizhiti.svg')
              : require('../assets/image/bigdata/pc_p2_dizhiti.png')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p2_guanxian.svg')
              : require('../assets/image/bigdata/pc_p2_guanxian.png')
          "
          alt=""
          draggable="false"
        />
        <div class="tip-line" v-for="item in 4" :key="item"></div>
      </div>

      <div class="menu" ref="menu" @touchstart="menuHandle">
        <div
          class="menu-item"
          data-set="YGActive"
          data-leave="0"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
      
        >
          <img
            :src="
              YGActive
                ? require('../assets/image/bigdata/menu-yaogan-active.svg')
                : require('../assets/image/bigdata/menu-yaogan.svg')
            "
            draggable="false"
            alt=""
          />
          <p>遥感数据</p>
          <div
            class="rightBottom"
            :style="activeName === 'YGActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="DXActive"
          data-leave="1"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
           
        >
          <img
            :src="
              DXActive
                ? require('../assets/image/bigdata/menu-dixingtu-active.svg')
                : require('../assets/image/bigdata/menu-dixingtu.svg')
            "
            draggable="false"
            alt=""
          />
          <p>地形图</p>
          <div
            class="leftBottom"
            :style="activeName === 'DXActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="DEMActive"
          data-leave="2"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
          
        >
          <img
            :src="
              DEMActive
                ? require('../assets/image/bigdata/menu-dem-active.svg')
                : require('../assets/image/bigdata/menu-dem.svg')
            "
            draggable="false"
            alt=""
          />
          <p>DEM</p>
          <div
            class="rightBottom"
            :style="
              activeName === 'DEMActive' ? { opacity: 1 } : { opacity: 0 }
            "
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="JMActive"
          data-leave="3"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              JMActive
                ? require('../assets/image/bigdata/menu-jianmo-active.svg')
                : require('../assets/image/bigdata/menu-jianmo.svg')
            "
            draggable="false"
            alt=""
          />
          <p>手工建模</p>
          <div
            class="leftBottom"
            :style="activeName === 'JMActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="SYActive"
          data-leave="4"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
           
        >
          <img
            :src="
              SYActive
                ? require('../assets/image/bigdata/menu-sheying-active.svg')
                : require('../assets/image/bigdata/menu-sheying.svg')
            "
            draggable="false"
            alt=""
          />
          <p>倾斜摄影</p>
          <div
            class="rightTop"
            :style="activeName === 'SYActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="DYActive"
          data-leave="5"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              DYActive
                ? require('../assets/image/bigdata/menu-dianyun-active.svg')
                : require('../assets/image/bigdata/menu-diancloud.svg')
            "
            draggable="false"
            alt=""
          />
          <p>点云</p>
          <div
            class="leftTop"
            :style="activeName === 'DYActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="BIMActive"
          data-leave="6"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              BIMActive
                ? require('../assets/image/bigdata/menu-bim-active.svg')
                : require('../assets/image/bigdata/menu-bim.svg')
            "
            draggable="false"
            alt=""
          />
          <p>BIM</p>
          <div
            class="rightTop"
            :style="
              activeName === 'BIMActive' ? { opacity: 1 } : { opacity: 0 }
            "
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="CADActive"
          data-leave="7"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              CADActive
                ? require('../assets/image/bigdata/menu-cad-active.svg')
                : require('../assets/image/bigdata/menu-cad.svg')
            "
            draggable="false"
            alt=""
          />
          <p>CAD</p>
          <div
            class="leftTop"
            :style="
              activeName === 'CADActive' ? { opacity: 1 } : { opacity: 0 }
            "
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="VDActive"
          data-leave="8"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              VDActive
                ? require('../assets/image/bigdata/menu-video-active.svg')
                : require('../assets/image/bigdata/menu-video.svg')
            "
            draggable="false"
            alt=""
          />
          <p>视频</p>
          <div
            class="rightTop"
            :style="activeName === 'VDActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="IOTActive"
          data-leave="9"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              IOTActive
                ? require('../assets/image/bigdata/menu-wulianwang-active.svg')
                : require('../assets/image/bigdata/menu-wulainwang.svg')
            "
            draggable="false"
            alt=""
          />
          <p>物联网数据</p>
          <div
            class="leftTop"
            :style="
              activeName === 'IOTActive' ? { opacity: 1 } : { opacity: 0 }
            "
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="ITActive"
          data-leave="10"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              ITActive
                ? require('../assets/image/bigdata/menu-hulianwang-active.svg')
                : require('../assets/image/bigdata/menu-hulianwang.svg')
            "
            draggable="false"
            alt=""
          />
          <p>互联网数据</p>
          <div
            class="rightTop"
            :style="activeName === 'ITActive' ? { opacity: 1 } : { opacity: 0 }"
          ></div>
        </div>
        <div
          class="menu-item"
          data-set="MoreActive"
          data-leave="11"
          @mouseenter="moveIn"
          @mouseleave="mouseLeave"
        >
          <img
            :src="
              MoreActive
                ? require('../assets/image/bigdata/menu-more-active.svg')
                : require('../assets/image/bigdata/menu-more.svg')
            "
            draggable="false"
            alt=""
          />
          <p>更多…</p>
          <div
            class="leftTop"
            :style="
              activeName === 'MoreActive' ? { opacity: 1 } : { opacity: 0 }
            "
          ></div>
        </div>
      </div>
    </section>

    <section :class="['sec-3', { active: n > 2 }]" ref="sec3">
      <div class="content">
        <h3 :class="['title textfade', { textfade1: n > 2 }]">
          强大的平台服务支持能力
        </h3>
        <p :class="['text textfade', { textfade2: n > 2 }]">
          基于城市孪生底座的大规模数据加载和单体数据更新能力，平台打造以多源异构的数据处理、标准地图发布、数据分布式存储等应用服务能力，以达到数据快速加载显示、场景灵活适配的空间信息服务平台，为“城市CIM平台”和“时空大数据平台”提供强大的标准化接入能力。
        </p>
      </div>

      <div :class="['imgs', { active: n > 2 }]" v-if="n > 0">
        <img
          class="bg"
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/section3-banner.png')
              : require('../assets/image/bigdata/section3-banner.jpg')
          "
          alt=""
          srcset=""
          draggable="false"
        />

        <div class="data-stream">
          <img
            :src="
              isMobile
                ? require('../assets/image/bigdata/mobile/section3.png')
                : require('../assets/image/bigdata/section3.png')
            "
            alt=""
            draggable="false"
          />
        </div>

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_update.svg')
              : require('../assets/image/bigdata/pc_p3_update.svg')
          "
          alt=""
          draggable="false"
        />

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_handle.svg')
              : require('../assets/image/bigdata/pc_p3_handle.svg')
          "
          alt=""
          draggable="false"
        />

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_ditu.svg')
              : require('../assets/image/bigdata/pc_p3_ditu.svg')
          "
          alt=""
          draggable="false"
        />

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_scene.svg')
              : require('../assets/image/bigdata/pc_p3_scene.svg')
          "
          alt=""
          draggable="false"
        />

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_yun.svg')
              : require('../assets/image/bigdata/pc_p3_yun.svg')
          "
          alt=""
          draggable="false"
        />

        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_x1.svg')
              : require('../assets/image/bigdata/pc_p3_x1.svg')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_x2.svg')
              : require('../assets/image/bigdata/pc_p3_x2.svg')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_x3.png')
              : require('../assets/image/bigdata/pc_p3_x3.svg')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_x4.svg')
              : require('../assets/image/bigdata/pc_p3_x4.svg')
          "
          alt=""
          draggable="false"
        />
        <img
          :src="
            isMobile
              ? require('../assets/image/bigdata/mobile/y_p3_x5.svg')
              : require('../assets/image/bigdata/pc_p3_x5.svg')
          "
          alt=""
          draggable="false"
        />

        <img
          src="../assets/image/bigdata/pc_p3_y1.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y2.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y3.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y4.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y5.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y6.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y7.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y8.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_y9.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z1.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z2.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z3.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z4.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z5.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z6.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/pc_p3_z7.png"
          alt=""
          v-if="!isMobile"
          draggable="false"
        />

        <img
          src="../assets/image/bigdata/mobile/y_p3_y1.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_y2.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_y3.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_y4.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_y5.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_y6.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_y7.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_z1.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
        <img
          src="../assets/image/bigdata/mobile/y_p3_z2.png"
          alt=""
          v-if="isMobile"
          draggable="false"
        />
      </div>
    </section>

    <!-- <section :class="['sec-4', { active: n > 3 }]" ref="sec4">
      <div class="back-img">
        <div class="content">
          <h3 :class="['title textfade', { textfade1: n > 3 }]">
            数据管理可视化
          </h3>
          <p :class="['text textfade', { textfade2: n > 3 }]">
            为用户提供可视化的数据及服务管理界面，提供数据归档，数据统计、在线发布，可视化检索等功能。同时基于自研AI超算平台，提供云端数据处理服务。简化用户操作流程，提升数据管理工作效率。
          </p>
        </div>
        <div class="computerImg">
          <img
            :src="
              isMobile
                ? require('../assets/image/bigdata/mobile/section4.png')
                : require('../assets/image/bigdata/section-4.png')
            "
            alt=""
            draggable="false"
          />
        </div>
      </div>
    </section> -->

    <!-- <section :class="['sec-5', { active: n > 4 }]" ref="sec5">
      <div class="content">
        <h3 :class="['title textfade', { textfade1: n > 4 }]">应用场景</h3>
      </div>

      <div class="container">
        <div class="swiper-container swiper-5">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in banners"
              :key="index"
            >
              <div class="img-wrap">
                <img
                  :class="`img-${index + 1}`"
                  :src="item.img"
                  alt=""
                  draggable="false"
                />
              </div>
              <div class="txt">
                <h4>{{ item.title }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <foot></foot>
  </div>
</template>
<script>
import { isMobile } from "../js/utils";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import  "@/assets/image/bigdata/section2.png";
export default {
  name: "space",
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "AIRLOOK, 埃洛克航空, 倾斜摄影, 数据服务, 高精度地图, 超算平台, DataEarth, GIS, 人工智能, 卫星影像, 正摄影像, 激光点云, 全景图, U3D, AR, MAP",
      },
      {
        name: "description",
        content:
          "AIRLOOK 埃洛克航空科技（北京）有限公司，凭借着雄厚的无人机技术积累以及对于产品的极致追求，提供顶尖工业无人机飞行控制系统以及无人机行业解决方案。",
      },
    ],
  },
  components: {
    Foot: () => import("../components/footer"),
    // ToTop: () => import('../components/ToTop'),
    ShowMore: () => import("../components/common/ShowMore")
  },
  data() {
    return {
      windowWidth: 0,
      banners: [
        {
          img: require("@/assets/image/bigdata/1.jpg"),
          title: "新型基础测绘",
        },
        {
          img: require("@/assets/image/bigdata/2.jpg"),
          title: "自然资源管理",
        },
        {
          img: require("@/assets/image/bigdata/3.jpg"),
          title: "国土空间规划",
        },
        {
          img: require("@/assets/image/bigdata/4.jpg"),
          title: "智慧城市运营",
        },
        {
          img: require("@/assets/image/bigdata/5.jpg"),
          title: "城市应急指挥",
        },
        {
          img: require("@/assets/image/bigdata/6.jpg"),
          title: "社会综合治理",
        },
      ],
      swiper: null,
      isMobile: false,
      n: 0,
      h: {
        h1: 0,
        h2: 0,
        h3: 0,
        h4: 0,
      },
      active: 0,
      activeName: "",
      leaveActive: 0,
      YGActive: false,
      DXActive: false,
      DEMActive: false,
      JMActive: false,
      SYActive: false,
      DYActive: false,
      BIMActive: false,
      CADActive: false,
      VDActive: false,
      IOTActive: false,
      ITActive: false,
      MoreActive: false,
      activeTimer: null,
      actives: [
        "YGActive",
        "DXActive",
        "DEMActive",
        "JMActive",
        "SYActive",
        "DYActive",
        "BIMActive",
        "CADActive",
        "VDActive",
        "IOTActive",
        "ITActive",
        "MoreActive",
      ],
    };
  },
  mounted() {
    this.isMobile = window.innerWidth <= 600 || isMobile();
    this.windowWidth = window.innerWidth;
    this.$nextTick(() => {
      this.getHeight();
    });
    setTimeout(() => {
      this.n = 1;
    }, 2000);
    window.addEventListener("scroll", this.scrollEvent);
    window.addEventListener("resize", this.resize);
    this.autoTimer();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
    clearInterval(this.activeTimer);
  },
  methods: {
    setHeight() {
			let height = this.$refs.sec1.offsetHeight + 'px'
			this.$refs.sec1.style.height = height
		},
    scrollEvent() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let { h1, h2, h3, h4 } = this.h;
      if (scrollTop > h1 * 0.6 && this.n < 2) {
        this.n = 2;
      }
      if (scrollTop > h1 + h2 * 0.6 && this.n < 3) {
        this.n = 3;
      }
      if (scrollTop > h1 + h2 + h3 * 0.7 && this.n < 4) {
        this.n = 4;
        this.$nextTick(this.initSwiper);
      }
      if (scrollTop > h1 + h2 + h3 + h4 * 0.6 && this.n < 5) {
        this.n = 5;
      }
    },
    handleSecond() {
			let h = this.$refs.sec1.offsetHeight
			let scrollTo = () => {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop < h && h - scrollTop > 15) {
					document.documentElement.scrollTop = scrollTop + (h - scrollTop) * 0.15
					document.body.scrollTop = scrollTop + (h - scrollTop) * 0.15
					window.requestAnimationFrame(scrollTo)
				}else {
					document.documentElement.scrollTop = h
					document.body.scrollTop = h 
				}
			}
			scrollTo()
		},
    resize() {
      this.windowWidth = window.innerWidth;
      this.getHeight();
    },
    getHeight() {
      if (
        this.$refs.sec1 &&
        this.$refs.sec2 &&
        this.$refs.sec3 
      ) {
        let h1 = this.$refs.sec1.offsetHeight;
        let h2 = this.$refs.sec2.offsetHeight;
        let h3 = this.$refs.sec3.offsetHeight;
        // let h4 = this.$refs.sec4.offsetHeight;
        this.h = { h1, h2, h3 };
      }
    },
    goTop() {
      this.swiper.slideTo(0);
    },
    initSwiper() {
      if (this.swiper) {
        return this.swiper;
      }
      this.swiper = new Swiper(".swiper-5", {
        slidesPerView: this.isMobile ? 2 : 3,
        initialSlide: 0,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 1,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        observer: true,
        observeParents: true,
        setWrapperSize: true,
        speed: 500,
      });
    },
    menuHandle(e){
      const target = e.target.closest('.menu-item');
      if(!target) return;
      clearInterval(this.activeTimer);
      this.setValue(target.dataset.set);
    },
    moveIn(e) {
      clearInterval(this.activeTimer);
      this.setValue(e.target.dataset.set);
    },
    mouseLeave(e) {
      let active = parseInt(e.target.dataset.leave);
      this.autoTimer(active);
    },
    setValue(value) {
      this.activeName = value;
      this.YGActive = value === "YGActive";
      this.DXActive = value === "DXActive";
      this.DEMActive = value === "DEMActive";
      this.JMActive = value === "JMActive";
      this.SYActive = value === "SYActive";
      this.DYActive = value === "DYActive";
      this.BIMActive = value === "BIMActive";
      this.CADActive = value === "CADActive";
      this.VDActive = value === "VDActive";
      this.IOTActive = value === "IOTActive";
      this.ITActive = value === "ITActive";
      this.MoreActive = value === "MoreActive";
    },
    autoTimer(active) {
      this.active = active <= this.actives.length ? active : 0;
      this.setValue(this.actives[this.active]);
      this.activeTimer = setInterval(() => {
        this.setValue(this.actives[this.active]);
        this.active = this.active + 1;
        if (this.active >= 12) {
          this.active = 0;
        }
      }, 1200);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/css/vivify.min.css";
@import "../assets/css/bigdata.scss";
/*隐藏滚动条*/
/*body::-webkit-scrollbar {*/
/*    display: none;*/
/*}*/
</style>
